import { IDependentValues } from '../../../@types/workspaceTypes';
import React from 'react';
import { Button, ButtonProps } from '@fluentui/react-components';
import { IButtonFormatterOptions } from '../../../@types/editableDataGridTypes';

/**
 * Displays a Fluent UI button with an onClick option
 *
 * @param dependentValues - data and formatting options
 */
const ButtonFormatter = ({ dependentValues }: { dependentValues: IDependentValues }) => {
  const options: IButtonFormatterOptions = dependentValues.options;
  const buttonProps: ButtonProps | undefined = options.buttonProps;

  if (options?.isDisabled(dependentValues.rowIdx, dependentValues.rowData) && options.disabledComponent) {
    return options.disabledComponent();
  }
  return (
    <Button
      {...buttonProps}
      onClick={() => {
        options?.onClick(dependentValues.rowIdx, dependentValues.rowData);
      }}
      disabled={!!options?.isDisabled(dependentValues.rowIdx, dependentValues.rowData)}
    >
      {options.label}
    </Button>
  );
};

export default ButtonFormatter;
